export const UPDATE_SELLER_PAGINATION = 'UPDATE_SELLER_PAGINATION';

interface SellerPaginationState {
    pagePath: string;
    numberOfPages: number;
    currentPage: number;
}

const initialState = { pagePath: '', numberOfPages: 0, currentPage: 0 };

export const updateSellerPagination = ({ pagePath, numberOfPages, currentPage }) => ({
    type: UPDATE_SELLER_PAGINATION,
    payload: { pagePath, numberOfPages, currentPage },
});

export default (state: SellerPaginationState = initialState, action): SellerPaginationState =>
    action.type === UPDATE_SELLER_PAGINATION ? { ...state, ...action.payload } : state;
